import { Component } from 'react';
// The State App Management
import store from "../../../../store/index";

/* Features Mods - Player <==> Library */
import RouteRoot from "../../route/Root";
import TooltipRoot from "../../tooltip/Root";
import ShortCutRoot from "../../shortcut/Root";
// import NavControlRoot from "../../nav-control/Root"; // DEPRECATED
import AutomixRoot from "../../automix/Root";
import IframeRoot from "./mods/iframe/Root";

const extender = (...parts) => parts.reduce((root, feature) => feature(root, store), Component);

/* Public Methods Available For LRoot */
class CustomRoot extends extender(
  RouteRoot,
  TooltipRoot,
  ShortCutRoot,
  // NavControlRoot,
  AutomixRoot,
  IframeRoot
) {}

export default CustomRoot;
